__turbopack_context__.v({
  "className": "inter_ac60b1e5-module__ofpbQW__className",
  "variable": "inter_ac60b1e5-module__ofpbQW__variable",
});
